import { Box, SxProps, Theme, Typography } from '@mui/material';

import { GuideArea } from '../ServiceGuide';

interface ContentItemProps {
  area: GuideArea;
  contentStyle?: SxProps<Theme>; // 컨텐츠 박스
  // labelStyle?: SxProps<Theme>; // 라벨 스타일
  badgeStyle?: SxProps<Theme>; // 뱃지(fieldName) 스타일
  showBadge?: boolean; // 뱃지 표시 여부
}

export const ContentItem = ({
  area,
  contentStyle,
  // labelStyle,
  badgeStyle,
  showBadge = true,
}: ContentItemProps) => (
  <Box
    component="button"
    sx={{
      height: 'inherit',
      width: '100%',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      p: 1,
      position: 'relative',
      border: 'none',
      background: 'none',
      cursor: 'pointer',
      ...contentStyle,
    }}
  >
    <Typography
      sx={{
        opacity: 0.8,
        ...(area.style?.typography ?? {}),
        // ...labelStyle,
      }}
    >
      {area.label}
    </Typography>
    {showBadge && (
      <Typography
        variant="caption"
        sx={{
          position: 'absolute',
          top: 3,
          right: 4,
          backgroundColor: 'background.paper',
          px: 1,
          borderRadius: '4px',
          fontSize: '10px',
          opacity: 0.7,
          ...badgeStyle,
        }}
      >
        {area.fieldName}
      </Typography>
    )}
  </Box>
);
